<template>
  <div>
    <div class="admin-table bg-white md:p-8 p-5">

      <div class="w-full justify-between mb-7">
        <div class="flex items-center mb-6 md:mb-3 space-x-2 justify-between md:justify-start">
          <div class="flex space-x-2">
            <h2>Users</h2>
            <span class="pt-2" v-if="isFiltered">{{ usersCount }} of {{ allUsersCount }} results</span>
          </div>
          <div class="mt-2" v-if="isFiltered">
            <a class="font-medium cursor-pointer clear-filter" @click="clearFilters">Clear Filter</a>
          </div>
        </div>
        <div class="md:flex justify-end md:space-x-4 md:space-y-0 space-y-4 mb-1">
          <div class="w-full md:w-auto inline-block">
            <vs-input
              id="users-user-name-search-input"
              icon-no-border
              icon="speakol-search"
              icon-pack="speakol"
              v-model="agFilters.searchText"
              placeholder="User name, email or phone"
              class="w-full"/>
          </div>

          <!-- Date range picker -->
          <div class="md:w-auto md:inline-block">
            <speakol-date-range-picker
              id="users-date-range-picker-input"
              v-model="agFilters.dateRange"
              class="w-full mb-8 lg:input lg:mr-4">
            </speakol-date-range-picker>
          </div>
          <!-- End Date range picker -->

          <div class="w-full md:w-auto inline-block">
            <vs-button id="users-filter-button" class="w-full font-bold rounded speakol-bg md:mb-4 md:mt-0 mt-2 mb-5 px-12" size="medium"
                    @click="loadUsers()">Filter
            </vs-button>
          </div>
        </div>
      </div>

      <!-- Start of System Users Table-->
      <a-g-speakol-table
        ref="systemUsersTable"
        :filters="agFilters"
        :columns="columns"
        :options="options"
        @dataChange="handleDataChange">
      </a-g-speakol-table>
      <!-- End of System Users Table-->

    </div>
  </div>
</template>

<script>
import {get} from 'lodash'
import EmptyTable from '@/components/EmptyTable'

import AGSpeakolTable from '@/components/AGSpeakolTable'

import SystemUsersDataSource from '@/datasources/SystemUsersDataSource'

import formatPhoneNumber from '@/helpers/formatPhoneNumber'

import DateTime from './components/DateTime'
import UserName from './components/UserName'
import UserMenu from './components/UserMenu'

export default {
  data () {
    return {
      options: this.getTableOptions(),
      columns: this.getTableColumns(),
      agFilters: this.getTableFilters(),

      isFiltered: false,
      usersCount: 0,
      allUsersCount: 0
    }
  },
  components: {
    EmptyTable,
    AGSpeakolTable,
    DateTime,
    UserName,
    UserMenu: {
      components: {
        UserMenu
      },
      template: '<UserMenu v-if="params.data" :userData="params.data" />'
    }
  },

  methods: {
    async loadUsers () {
      if (this.isFiltered === false) {
        this.allUsersCount = this.$refs['systemUsersTable'].getTotalRows()
      }

      this.isFiltered = true

      await this.$refs['systemUsersTable'].applyFilters()
    },

    async clearFilters () {
      this.agFilters.page = 1

      this.agFilters.searchText = ''

      this.agFilters.dateRange.startDate = new Date('January 1, 2016')
      this.agFilters.dateRange.endDate = new Date()

      this.isFiltered = false

      this.$refs['systemUsersTable'].applyFilters()
    },

    getTableColumns () {
      return [
        {
          headerName: 'Name',
          field: 'name',
          sortable: true,
          minWidth: 396,
          cellRendererFramework: 'UserName'
        },
        {
          headerName: 'Phone',
          field: 'phone',
          minWidth: 180,
          sortable: true,
          valueGetter (params) {
            const countryCode = get(params, 'data.country.code', 'EG')
            const phoneNumber = get(params, 'data.phone', '')
            return formatPhoneNumber({ countryCode, phoneNumber })
          }
        },
        {
          headerName: 'Registration Time',
          field: 'created_at',
          cellRendererFramework: 'DateTime',
          minWidth: 210,
          sortable: true
        },
        {
          headerName: 'Last Login',
          field: 'last_login_at',
          minWidth: 310,
          cellRendererFramework: 'DateTime',
          sortable: true
        },
        {
          headerName: 'Actions',
          field: 'action',
          minWidth: 100,
          cellRendererFramework: 'UserMenu',
          resizable: false
        }
      ]
    },

    getTableOptions () {
      return {
        dataSource: SystemUsersDataSource,
        rowHeight: 56
      }
    },

    getTableFilters () {
      return {
        searchText: '',
        dateRange: {
          startDate: new Date('January 1, 2016'),
          endDate: new Date()
        }
      }
    },

    handleDataChange ({ totalItems }) {
      this.usersCount = totalItems
    }
  }
}
</script>

<style lang="scss">
$speakolColor: #0092d7 !important;

.ag-cell-wrapper {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.clear-filter {
  color: $speakolColor;
}
</style>
